import React,{useEffect, useState} from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { Link, useNavigate} from 'react-router-dom';
import { SvgComponent } from "../SvgComponent/SvgComponent";
import "./ShortcutButton.style.css";
import { useAuthentication } from "../../Hooks";
import ToolTip from "../ToolTip/Tooltip";

const Dp = Dropdown;
export const ShortcutButton = () => {
  const [top5Items, setTop5Item] = useState(null);
  const navigate = useNavigate();
  const {usuario} = useAuthentication();
  function manageGoTo(url){
    navigate(url)
  }

  useEffect(() => {
    if(usuario){
      const allSubmenus = usuario?.Menus?.flatMap((menu) => menu.Submenu);
      const top = allSubmenus.sort((a, b) => b.Frecuencia - a.Frecuencia).slice(0, 5);
      setTop5Item(top.sort((a, b) => a.Nombre.toLowerCase().localeCompare(b.Nombre.toLowerCase()))); 
    }
  }, [usuario]);
  return (
    <>
      <Dp as={Nav.Item}>
        <Dp.Toggle
          as={Nav.Link}
          id="Dp-41471887333"
          className="buttonHover"
        >
          <ToolTip placement="left" message="Favoritos">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              fill="#77777A"
              height="33"
              viewBox="0 -960 960 960"
            >
              <path
                d="M459.539-290.001h45.383v-164.461h165.077v-45.384H504.922v-170.153h-45.383v170.153H290.001v45.384h169.538v164.461Zm20.794 190q-78.955 0-147.897-29.92t-120.755-81.71q-51.814-51.791-81.747-120.777t-29.933-148.025q0-78.655 29.92-147.864t81.71-120.522q51.791-51.314 120.777-81.247t148.025-29.933q78.655 0 147.864 29.92t120.522 81.21q51.314 51.291 81.247 120.629 29.933 69.337 29.933 147.907 0 78.955-29.92 147.897t-81.21 120.571q-51.291 51.629-120.629 81.746-69.337 30.118-147.907 30.118Zm.167-45.384q139.192 0 236.654-97.769 97.461-97.769 97.461-237.346 0-139.192-97.274-236.654Q620.067-814.615 480-814.615q-139.077 0-236.846 97.274T145.385-480q0 139.077 97.769 236.846T480.5-145.385ZM480-480Z"
              />
            </svg>
          </ToolTip>
        </Dp.Toggle>
        <Dp.Menu alignRight aria-labelledby="navbarDpMenuLink">
        {top5Items &&
            top5Items.map((m, index) => (
              <Dp.Item
              as={Link}
              to={m.URL}
              onClick={(e) => {
                e.preventDefault()
                manageGoTo(m.URL)
              }}
              key={index}
              >
                <SvgComponent
                  height="28"
                  width="28"
                  iconName="submenu"
                  fill="#2f2f2f"
                  style={{ marginRight: "8px", marginBottom: "5px" }}
                />
                {m.Nombre}
              </Dp.Item>
            ))}
        </Dp.Menu>
      </Dp>
    </>
  );
}
